import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact";
import { useEffect, useState } from "preact/hooks";
import { productImagePlaceholder, getSwatches, addToCart } from "../helpers";

export default function Product({ product }) {
  const { format } = useCurrencyFormatting();
  const tags = [
    product.onSale
      ? {
          label: "Sale",
          class:
            "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center",
        }
      : undefined,
  ].filter((v) => !!v);

  const [swatches, setSwatches] = useState([]);
  const [isPlusToShow, setIsPlusToShow] = useState(null);

  const gid = product?.customFields?.find(
    (field) => field.key === "custom-collection"
  )?.value;

  useEffect(() => {
    getSwatches(gid, product?.productId).then((data) => {
      setSwatches(data.swatchesArr);
      setIsPlusToShow(data.isPlusToShow);
    });
  }, [product]);

  const callOutMsg = product?.customFields?.find(field => field.key === 'custom-call_out_message')?.value || '';
  const salesMsg = product?.customFields?.find(field => field.key === 'custom-sales_messaging')?.value || '';
  const stockStatus = product?.availability === "InStock";
  // console.log(product);

  return (
    <SerpElement
      as="li"
      hit={product}
      class="ns-product grid__item"
      // class="ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit ns-col-12 ns-col-xs-6 ns-col-l-4 ns-p-2 ns-my-2 ns-mx-0"
    >
      <div class="card-wrapper product-card-wrapper product-center  product-card--portrait">
        <div class="card" data-product-card-id={product?.productId}>
          <div class="product-badges badges text-xs">
            {!stockStatus && (<span class="badges__badge  badge--sold-out">Sold out</span>)}
            {product?.listPrice > product?.price ? (
              <span class="badges__badge badge--sale">Sale</span>
            ) : product?.tags1?.includes("new") ? (
              <span class="badges__badge badge--new">New</span>
            ) : (
              ""
            )}
            {product?.tags1?.includes("ECO") && (
              <span class="badges__badge badge--eco">
                <svg
                  class="icon icon-eco "
                  width="31"
                  height="31"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  role="graphics-symbol"
                  focusable="false"
                >
                  <title>Eco </title>
                  <path
                    d="M9.47739 15.6035C9.47739 15.8409 9.45913 16.0966 9.44087 16.3705H2.64783C2.88522 17.7583 3.90783 18.4705 5.27739 18.4705C6.28174 18.4705 7.21304 18.014 7.68783 17.2287L9.11217 17.9409C8.36348 19.3653 6.82956 20.1322 5.20435 20.1322C2.73913 20.1322 0.803478 18.3244 0.803478 15.6218C0.803478 12.9192 2.77565 11.1661 5.20435 11.1661C7.63304 11.1661 9.47739 12.9192 9.47739 15.6035ZM2.66609 14.9279H7.68783C7.50522 13.5948 6.53739 12.8279 5.22261 12.8279C3.90783 12.8279 2.92174 13.5035 2.66609 14.9279ZM15.6048 20.1322C13.1396 20.1322 11.003 18.3427 11.003 15.64C11.003 12.9374 13.1396 11.1661 15.6048 11.1661C16.9926 11.1661 18.1796 11.7322 18.9282 12.627L17.7413 13.7409C17.2482 13.1931 16.4996 12.8461 15.6413 12.8461C14.0526 12.8461 12.7926 14.0148 12.7926 15.64C12.7926 17.2653 14.0526 18.4522 15.6413 18.4522C16.4996 18.4522 17.2482 18.1053 17.7413 17.5574L18.9282 18.6713C18.1796 19.5661 16.9926 20.1322 15.6048 20.1322Z"
                    fill="black"
                  ></path>
                  <path
                    d="M27.843 12.5632C27.6589 12.394 27.4631 12.2402 27.257 12.1032L27.2566 12.103C26.5782 11.654 25.8126 11.4138 25.0421 11.4138C23.8143 11.4138 22.687 11.9736 21.8693 12.9759L21.8693 12.9759C21.1483 13.8598 20.7179 15.0468 20.7179 16.1604C20.7179 16.3914 20.8925 16.6184 21.1546 16.6184C21.4167 16.6184 21.5913 16.3914 21.5913 16.1604C21.5913 15.2661 21.9431 14.2949 22.5331 13.5718M27.843 12.5632L26.9057 14.2432C26.6444 14.2338 26.4775 14.0016 26.4843 13.7712C26.4912 13.5399 26.6733 13.3182 26.936 13.3278C26.936 13.3278 26.936 13.3278 26.9361 13.3278C26.9361 13.3278 26.9361 13.3278 26.9361 13.3278L27.3632 13.3434C27.1855 13.1688 26.9936 13.0129 26.7898 12.8776C26.2453 12.5172 25.6408 12.3297 25.0421 12.3297C24.0814 12.3297 23.1908 12.7658 22.5331 13.5718M27.843 12.5632L27.8354 12.3121L27.8354 12.3094L28.066 12.3025L28.0659 12.2976M27.843 12.5632L26.9059 14.2432L28.2081 14.2907C28.3674 14.34 28.5375 14.2893 28.6484 14.1667L28.6485 14.1666C28.7574 14.0462 28.7928 13.8777 28.7516 13.7258L28.7085 12.2814L28.7085 12.2806L28.4778 12.2875M22.5331 13.5718L22.3543 13.4259L22.5331 13.5718ZM28.4778 12.2875C28.4753 12.162 28.381 12.0626 28.2672 12.0654C28.1536 12.0682 28.0633 12.1723 28.0659 12.2976M28.4778 12.2875L28.5219 13.7644L28.4778 12.2875ZM28.0659 12.2976H27.8351L27.8351 12.2977C27.8351 12.298 27.8351 12.2985 27.8351 12.2993C27.8351 12.3003 27.8352 12.3014 27.8352 12.3024L28.0659 12.2976Z"
                    fill="black"
                    stroke="black"
                    stroke-width="0.461538"
                  ></path>
                  <path
                    d="M23.0718 18.4835C23.2494 18.658 23.4413 18.8139 23.6451 18.9492C24.1895 19.3096 24.794 19.4969 25.3927 19.4969C26.3535 19.4969 27.2441 19.061 27.9017 18.2551C28.4917 17.5319 28.8435 16.5607 28.8435 15.6664C28.8435 15.4353 29.0182 15.2084 29.2802 15.2084C29.5423 15.2084 29.717 15.4353 29.717 15.6664C29.717 16.7801 29.2865 17.9671 28.5655 18.851L28.5655 18.851C27.7479 19.8533 26.6205 20.4131 25.3927 20.4131C24.6222 20.4131 23.8566 20.1729 23.1782 19.7238L23.1778 19.7236C22.9718 19.5866 22.7759 19.4327 22.5919 19.2636L22.5994 19.5147L22.5995 19.5173L22.3688 19.5242L23.0718 18.4835ZM23.0718 18.4835L23.4989 18.499L23.499 18.499C23.7615 18.5084 23.9436 18.287 23.9505 18.0556C23.9574 17.825 23.7902 17.5931 23.5293 17.5835L23.5292 17.5835L22.2267 17.5361C22.0673 17.4868 21.8974 17.5377 21.7865 17.66L21.7863 17.6602C21.6774 17.7805 21.642 17.949 21.6832 18.1009L21.7263 19.5452M23.0718 18.4835L21.7263 19.5452M21.7263 19.5452L21.7263 19.5461L21.957 19.5392L21.7263 19.5452Z"
                    fill="black"
                    stroke="black"
                    stroke-width="0.461538"
                  ></path>
                </svg>
              </span>
            )}
          </div>
          <div class="card__inner">
            {stockStatus ? (<button
              class="button button--primary card__quickbuy desktop__quick-buy"
            //   onClick={(e) => {
            //     addToCart(product?.productId, product?.skus?.[0]?.id, e.target);
            //   }}
            >
              <svg
                class="icon icon-cart quickbuy__cart-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                role="graphics-symbol"
                focusable="false"
              >
                <title>Shopping Cart</title>
                <path
                  d="M3 5H6.36842L7.21053 13H17.3158L19 7.4H6.62105"
                  stroke="currentColor"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.5 20C8.32843 20 9 19.3284 9 18.5C9 17.6716 8.32843 17 7.5 17C6.67157 17 6 17.6716 6 18.5C6 19.3284 6.67157 20 7.5 20Z"
                  stroke="currentColor"
                  stroke-width="1"
                ></path>
                <path
                  d="M16.5 20C17.3284 20 18 19.3284 18 18.5C18 17.6716 17.3284 17 16.5 17C15.6716 17 15 17.6716 15 18.5C15 19.3284 15.6716 20 16.5 20Z"
                  stroke="currentColor"
                  stroke-width="1"
                ></path>
              </svg>
              <span class="quickbuy__text text-md card__variants">
                {product?.skus?.length > 1 && product?.skus?.map((sku) =>
                  sku?.availability === "InStock" ? (
                    <span class="variant-swatch " data-variant-id={sku.id}>
                      {" "}
                      {
                        sku?.customFields.find((field) => field?.key === "size")
                          ?.value
                      }{" "}
                    </span>
                  ) : (
                    <span
                      class="variant-swatch sold-out"
                      data-variant-id={sku.id}
                    >
                      {" "}
                      {
                        sku?.customFields.find((field) => field?.key === "size")
                          ?.value
                      }{" "}
                    </span>
                  )
                )}
                {product?.skus?.length === 1 && (
                    <span class="variant-swatch ns-atc-single-variant" data-variant-id={product?.skus[0].id} style="border:none;">
                    {" "}
                    {
                      "add to cart"
                    }{" "}
                  </span>
                )}
              </span>
            </button>):(
              <button class="button button--primary card__quickbuy desktop__quick-buy" disabled>
                <svg class="icon icon-cart quickbuy__cart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" role="graphics-symbol" focusable="false">
                    <title>Shopping Cart</title>
                    <path d="M3 5H6.36842L7.21053 13H17.3158L19 7.4H6.62105" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M7.5 20C8.32843 20 9 19.3284 9 18.5C9 17.6716 8.32843 17 7.5 17C6.67157 17 6 17.6716 6 18.5C6 19.3284 6.67157 20 7.5 20Z" stroke="currentColor" stroke-width="1"></path>
                    <path d="M16.5 20C17.3284 20 18 19.3284 18 18.5C18 17.6716 17.3284 17 16.5 17C15.6716 17 15 17.6716 15 18.5C15 19.3284 15.6716 20 16.5 20Z" stroke="currentColor" stroke-width="1"></path>
                </svg>
                <span class="quickbuy__text text-md">Sold out</span>
              </button>
            )}
            {stockStatus ? (<button
              type="button"
              class={`button button--primary card__quickbuy mobile__quick-buy ${product?.skus?.length > 1 ? 'open-sticky-modal' : ''}`} 
              product-handle={product?.productId} sku-handle={product?.skus?.[0]?.id}
              // onClick={(e) => {
              //   addToCart(product?.productId, product?.skus?.[0]?.id, e.target);
              // }}
            >
              <svg
                class="icon icon-cart quickbuy__cart-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                role="graphics-symbol"
                focusable="false"
              >
                <title>Shopping Cart</title>
                <path
                  d="M3 5H6.36842L7.21053 13H17.3158L19 7.4H6.62105"
                  stroke="currentColor"
                  stroke-width="1"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M7.5 20C8.32843 20 9 19.3284 9 18.5C9 17.6716 8.32843 17 7.5 17C6.67157 17 6 17.6716 6 18.5C6 19.3284 6.67157 20 7.5 20Z"
                  stroke="currentColor"
                  stroke-width="1"
                ></path>
                <path
                  d="M16.5 20C17.3284 20 18 19.3284 18 18.5C18 17.6716 17.3284 17 16.5 17C15.6716 17 15 17.6716 15 18.5C15 19.3284 15.6716 20 16.5 20Z"
                  stroke="currentColor"
                  stroke-width="1"
                ></path>
              </svg>

              <span class="quickbuy__text text-md card__variants">
              {product?.skus?.length > 1 && product?.skus?.map((sku) =>
                  sku?.availability === "InStock" ? (
                    <span class="variant-swatch " data-variant-id={sku.id}>
                      {" "}
                      {
                        sku?.customFields.find((field) => field?.key === "size")
                          ?.value
                      }{" "}
                    </span>
                  ) : (
                    <span
                      class="variant-swatch sold-out"
                      data-variant-id={sku.id}
                    >
                      {" "}
                      {
                        sku?.customFields.find((field) => field?.key === "size")
                          ?.value
                      }{" "}
                    </span>
                  )
                )}
                {/* {product?.skus?.length === 1 && (
                    <span class="variant-swatch " data-variant-id={product?.skus[0].id}>
                    {" "}
                    {
                      "add to cart"
                    }{" "}
                  </span>
                )} */}
              </span>
            </button>) : (
              <button type="button" class="button button--primary card__quickbuy mobile__quick-buy " disabled>
                <svg class="icon icon-cart quickbuy__cart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" role="graphics-symbol" focusable="false">
                    <title>Shopping Cart</title>
                    <path d="M3 5H6.36842L7.21053 13H17.3158L19 7.4H6.62105" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M7.5 20C8.32843 20 9 19.3284 9 18.5C9 17.6716 8.32843 17 7.5 17C6.67157 17 6 17.6716 6 18.5C6 19.3284 6.67157 20 7.5 20Z" stroke="currentColor" stroke-width="1"></path>
                    <path d="M16.5 20C17.3284 20 18 19.3284 18 18.5C18 17.6716 17.3284 17 16.5 17C15.6716 17 15 17.6716 15 18.5C15 19.3284 15.6716 20 16.5 20Z" stroke="currentColor" stroke-width="1"></path>
                </svg>
                <span class="quickbuy__text text-md">Sold out</span> 
              </button>
            )}
            <div class="card__media">
              <a href={`${product?.url}?variant=${product?.skus[0]?.id}`}>
                <div class="media media--extra">
                  <img
                    src={`${product?.imageUrl}&amp;width=800`}
                    sizes="
                        (min-width: 0px) 767,
                        (min-width: 768px) 1023,
                        (min-width: 1024) 1279,
                        (min-width: 1280px) 1535,
                        (min-width: 1536px) 1900,
                        100v
                        "
                    srcset={`${product?.imageUrl}&amp;width=240 240w,${product?.imageUrl}&amp;width=320 320w,${product?.imageUrl}&amp;width=480 480w,${product?.imageUrl}&amp;width=768 768w,${product?.imageUrl}800`}
                    alt={
                      product?.customFields.find(
                        (field) => field?.key === "global-title_tag"
                      )?.value
                    }
                    loading="eager"
                    width="800"
                    height="800"
                    class="item__image"
                  />
                  <img
                    src={`${
                      product?.alternateImageUrls.length > 0
                        ? product?.alternateImageUrls[0]
                        : product?.imageUrl
                    }&amp;width=800`}
                    sizes="
                        (min-width: 0px) 767,
                        (min-width: 768px) 1023,
                        (min-width: 1024) 1279,
                        (min-width: 1280px) 1535,
                        (min-width: 1536px) 1900,
                        100v
                        "
                    srcset={`${
                      product?.alternateImageUrls.length > 0
                        ? product?.alternateImageUrls[0]
                        : product?.imageUrl
                    }&amp;width=240 240w,${
                      product?.alternateImageUrls.length > 0
                        ? product?.alternateImageUrls[0]
                        : product?.imageUrl
                    }&amp;width=320 320w,${
                      product?.alternateImageUrls.length > 0
                        ? product?.alternateImageUrls[0]
                        : product?.imageUrl
                    }&amp;width=480 480w,${
                      product?.alternateImageUrls.length > 0
                        ? product?.alternateImageUrls[0]
                        : product?.imageUrl
                    }&amp;width=768 768w,${
                      product?.alternateImageUrls.length > 0
                        ? product?.alternateImageUrls[0]
                        : product?.imageUrl
                    }800`}
                    alt={
                      product?.customFields.find(
                        (field) => field?.key === "global-title_tag"
                      )?.value
                    }
                    loading="eager"
                    width="800"
                    height="800"
                    class="item__image--extra hidden"
                  />
                </div>
              </a>
            </div>
          </div>
          <div class="card__content">
          {salesMsg && (
                <div class="sales-message">
                {salesMsg}
              </div>)}
            <div class="card__information lg:flex items-flex-start swatch--inline_with_text">
              <div class="card__main flex-2">
                <div class="card__title">
                  <a
                    class="text-xs"
                    href={`${product?.url}?variant=${product?.skus[0]?.id}`}
                  >
                    {product?.name}
                  </a>
                </div>
                <div class="card__price text-xs">
                  <div class="price ">
                    <div class="price__container">
                      <span class="price__regular text-xs only__regular--price ">
                        {format(product?.price)}
                      </span>
                      <small class="unit-price caption hidden">
                        <span class="price__item price__item--last">
                          <span></span>
                          <span aria-hidden="true">/</span>
                          <span></span>
                        </span>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card__variants">
                <input type="hidden" name="id" value={product?.skus[0]?.id} />
              </div>
              {callOutMsg && (
                <div class="call-out-message call-out-message-mobile">
                {callOutMsg}
              </div>
              )}
              <div class="card__variants card__variants--custom flex-1">
                <product-swatches class="product_custom_swatches inline_with_text">
                  <div class="swatches--list swatches__list-grid">
                    {swatches &&
                      swatches?.map((swatch, index) => {
                        if (index === 0) {
                          return (
                            <a
                              class="swatch selected"
                              href={swatch?.url}
                              aria-label="View product"
                            >
                              <span
                                class="swatch__value--color"
                                style={`background-image: url(${
                                  swatch?.attributes?.find(
                                    (attr) =>
                                      attr?.key === "custom-colour_swatch"
                                  )?.value
                                });`}
                                role="img"
                                aria-label={`Colour swatch for ${
                                  swatch?.name
                                } ${
                                  swatch?.attributes?.find(
                                    (attr) =>
                                      attr?.key === "custom-mix_and_match_group"
                                  )?.value
                                }`}
                              ></span>
                            </a>
                          );
                        } else {
                          return (
                            <a
                              class="swatch"
                              href={swatch?.url}
                              aria-label="View product"
                            >
                              <span
                                class="swatch__value--color"
                                style={`background-image: url(${
                                  swatch?.attributes?.find(
                                    (attr) =>
                                      attr?.key === "custom-colour_swatch"
                                  )?.value
                                });`}
                                role="img"
                                aria-label={`Colour swatch for ${
                                  swatch?.name
                                } ${
                                  swatch?.attributes?.find(
                                    (attr) =>
                                      attr?.key === "custom-mix_and_match_group"
                                  )?.value
                                }`}
                              ></span>
                            </a>
                          );
                        }
                      })}
                    {isPlusToShow && <a
                      href={product?.url}
                      class="radio__more"
                      aria-label={`See more variants for ${product?.name}`}
                    >
                      <span class="sr-only">See more variants</span>
                      <svg
                        class="icon icon-plus--small icon"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        role="graphics-symbol"
                        focusable="false"
                      >
                        <title>Plus</title>
                        <path
                          d="M5.34609 3.99176H8.54609V5.79176H5.34609V9.01176H3.54609V5.79176H0.326094V3.99176H3.54609V0.771757H5.34609V3.99176Z"
                          fill="black"
                        ></path>
                      </svg>
                    </a>}
                  </div>
                  <div class="swatches--list swatches__list-drawer">
                    {swatches &&
                      swatches?.map((swatch, index) => {
                        if (index === 0) {
                          return (
                            <a
                              class="swatch selected"
                              href={swatch?.url}
                              aria-label="View product"
                            >
                              <span
                                class="swatch__value--color"
                                style={`background-image: url(${
                                  swatch?.attributes?.find(
                                    (attr) =>
                                      attr?.key === "custom-colour_swatch"
                                  )?.value
                                });`}
                                role="img"
                                aria-label={`Colour swatch for ${
                                  swatch?.name
                                } ${
                                  swatch?.attributes?.find(
                                    (attr) =>
                                      attr?.key === "custom-mix_and_match_group"
                                  )?.value
                                }`}
                              ></span>
                            </a>
                          );
                        } else {
                          <a
                            class="swatch"
                            href={swatch?.url}
                            aria-label="View product"
                          >
                            <span
                              class="swatch__value--color"
                              style={`background-image: url(${
                                swatch?.attributes?.find(
                                  (attr) => attr?.key === "custom-colour_swatch"
                                )?.value
                              });`}
                              role="img"
                              aria-label={`Colour swatch for ${swatch?.name} ${
                                swatch?.attributes?.find(
                                  (attr) =>
                                    attr?.key === "custom-mix_and_match_group"
                                )?.value
                              }`}
                            ></span>
                          </a>;
                        }
                      })}
                    {isPlusToShow && <a
                      href={product?.url}
                      class="radio__more"
                      aria-label={`See more variants for ${product?.name}`}
                    >
                      <span class="sr-only">See more variants</span>
                      <svg
                        class="icon icon-plus--small icon"
                        width="9"
                        height="10"
                        viewBox="0 0 9 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        role="graphics-symbol"
                        focusable="false"
                      >
                        <title>Plus</title>
                        <path
                          d="M5.34609 3.99176H8.54609V5.79176H5.34609V9.01176H3.54609V5.79176H0.326094V3.99176H3.54609V0.771757H5.34609V3.99176Z"
                          fill="black"
                        ></path>
                      </svg>
                    </a>}
                  </div>
                </product-swatches>
              </div>
            </div>
            {callOutMsg && (
              <div class="call-out-message call-out-message-desktop">
              {callOutMsg}
              </div>
            )}
          </div>
        </div>
        <div class="modal-overlay"></div>
        <div class="mobile-sticky-add">
            <span class="mobile-sticky-close">
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.61938L14.3333 15.2968M1 15.2968L14.3333 1.61938"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </span>
            <div class="mobile-title-wrap">
              <h4>{product?.name}</h4>
              <div class="price">
                <div class="price__container">
                  <span class="price__regular text-xs only__regular--price"
                    >{format(product?.price)}</span
                  >
                  <small class="unit-price caption hidden">
                    <span class="price__item price__item--last">
                      <span></span>
                      <span aria-hidden="true">/</span>
                      <span> </span>
                    </span>
                  </small>
                </div>
              </div>
            </div>
            <p class="sticky-option-name">Size</p>
            <button type="button" class="button button--primary card__quickbuy">
              <span class="quickbuy__text text-md card__variants">
                  {product?.skus?.map((sku) =>{
                    if(sku?.availability === "InStock"){
                      return(
                        <span class="variant-swatch-mobile" data-variant-id={sku?.id}>
                          {sku?.customFields.find((field) => field?.key === "size")?.value}
                        </span>
                      )
                    }else{
                      return(
                        <span class="variant-swatch-mobile sold-out" data-variant-id={sku?.id}>
                          {sku?.customFields.find((field) => field?.key === "size")?.value}
                        </span>
                      )
                    }
                  })}
              </span>
            </button>
            <button
              type="button"
              class="sticky-add-to-cart-variant sticky-add-to-cart button button--full-width button--primary text-lg"
            >
              Add to cart
            </button>
            <a
              class="sticky-view-details"
              href={product?.url}
              >view details
              </a>
          </div>
      </div>
    </SerpElement>
  );
}
